export const USER_REQUEST = "USER_REQUEST";
export const USER_OBSERVATIONS = "USER_OBSERVATIONS";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_OBS_SUCCESS = "USER_OBS_SUCCESS";
export const USER_ERROR = "USER_ERROR";
export const USER_PROPOSALS = "USER_PROPOSALS";
export const USER_PROPOSAL_SUCCESS = "USER_PROPOSAL_SUCCESS";
export const CHANGE_APERTURE = "CHANGE_APERTURE";
export const CHANGE_PROPOSAL = "CHANGE_PROPOSAL";
